<template>
  <modal
    :show.sync="showAddModalDriver"
    bodyClasses="pt-0"
    size="lg"
    @close="closeModal"
  >
    <template slot="header" class="pb-0">
      <h6 class="subtitle" id="modal-title-default">
        New Driver
      </h6>
    </template>
    <div class="row forms mt-4">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12">
        <label for="title" class="title-label">Gender</label>

        <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
          <b-form-radio-group
            id="radio-gender"
            v-model="driver.person.gender"
            :aria-describedby="ariaDescribedby"
            name="radio-gender"
            buttons
            button-variant="outline-neutral"
            size="md"
          >
            <b-form-radio value="male" class="pc-1">Mr.</b-form-radio>
            <b-form-radio value="female" class="pc-1">Mrs.</b-form-radio>
            <b-form-radio value="other" class="pc-1">Mx.</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </div>

      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
        <base-input
          v-model.trim="$v.driver.person.first_name.$model"
          inputClasses="text-capitalize"
          label="First Name"
          placeholder="First Name"
          id="ncfirst_name_driver"
          name="ncfirst_name_driver"
          markrequired
          tab-index="15"
          :error="
            !$v.driver.person.first_name.minLength ||
            $v.driver.person.first_name.$error
              ? `Minimum ${$v.driver.person.first_name.$params.minLength.min} letters.`
              : ''
          "
        />
      </div>

      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
        <base-input
          v-model.trim="$v.driver.person.last_name.$model"
          label="Last Name"
          inputClasses="text-capitalize"
          placeholder="Last Name"
          id="nclast_name_driver"
          name="nclast_name_driver"
          tab-index="16"
          :error="
            !$v.driver.person.last_name.minLength ||
            $v.driver.person.last_name.$error
              ? `Minimum ${$v.driver.person.last_name.$params.minLength.min} letters.`
              : ''
          "
        />
      </div>

      <div
        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 inputphone"
        v-bind:class="{ 'is-invalid': $v.driver.person.numbre_phone.$error }"
      >
        <label class="title-label"
          ><span class="markrequired">*</span>Contact Number</label
        >
        <vue-tel-input
          v-model="phoneNumber"
          key="NumberPhoneCustomer"
          inputId="NumberPhoneCustomer"
          name="NumberPhoneCustomer"
          required
          mode="international"
          inputClasses="input no-label no-err"
          :dynamicPlaceholder="true"
          :disabledFetchingCountry="true"
          :validCharactersOnly="true"
          :wrapperClasses="[
            $v.driver.person.numbre_phone.$error ? 'is-invalid' : '',
            'mb-0'
          ]"
          @input="phoneNumberEvent"
        ></vue-tel-input>
        <small
          class="invalid-feedback mt-1"
          v-if="$v.driver.person.numbre_phone.$error"
          >Enter a valid phone</small
        >
      </div>
      <div class="col-12 text-right">
        <base-button
          :disabled="send"
          type="primary"
          class="min-button mb-0"
          @click="saveDriver()"
        >
          <i class="flaticon-floppy-disk"></i> Save
        </base-button>
      </div>
    </div>
  </modal>
</template>

<script>
import lodash from "lodash";
import { mapGetters, mapActions, mapMutations } from "vuex";
import WSelect from "@/components/Select";
import { VueTelInput } from "vue-tel-input";
import { ReservationsAPI } from "../../../core/api";
import {
  required,
  minLength,
  maxLength,
  helpers
} from "vuelidate/lib/validators";
const ValName = helpers.regex("alphaCha", /^[a-zA-ZÑñáéíóúüüÜÁÉÍÓÚ'-\s]*$/);
import moment from "moment";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "add-driver",
  components: {
    VueTelInput,
    WSelect
  },
  props: {
    show: {
      type: Boolean,
      default: false,
      description: "(closeable)"
    },
    branchId: {
      type: [String],
      required: null
    }
  },
  data() {
    return {
      driver: {
        person: {
          first_name: "",
          last_name: "",
          full_name: "",
          gender: "",
          numbre_phone: ""
        },
        profile: {
          image: ""
        },
        address: {
          country: "",
          state: "",
          city: "",
          street: "",
          postal_code: "",
          house_phone: ""
        },
        license: {
          number: "",
          exppiration: "",
          image: ""
        },
        relationship: {
          type: "in-house",
          branch: "",
          hire_date: moment().format(),
          status: false,
          duty: "off",
          vehicle: null,
          vehicles: [],
          auto_assign: false
        },
        account: {
          email: "",
          status: true
        }
      },
      send: false,
      type: "driver",
      phoneNumber: "",
      showAddModalDriver: false
    };
  },
  async created() {
    this.driver.relationship.branch = this.branchId;
  },
  watch: {
    show: {
      handler: function(current, old) {
        this.showAddModalDriver = current;
      },
      deep: true
    },
    branchId: {
      handler: function(current, old) {
        this.driver.relationship.branch = current;
      },
      deep: true
    }
  },
  methods: {
    async saveDriver() {
      if (!this.$v.driver.$invalid) {
        let driver = lodash.cloneDeep(this.driver);
        driver.person.full_name = `${driver.person.first_name} ${driver.person.last_name}`;
        this.createDriver(this.branchId, driver);
      } else {
        this.$v.driver.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    async createDriver(branchId, driver) {
      try {
        this.send = true;
        let { data } = await ReservationsAPI.createPartialDriverProfile(
          branchId,
          driver,
          this.sesion.token
        );
        this.send = false;
        if (data.status) {
          let { driver } = data.data;
          if (driver) {
            this.$notify({
              type: "success",
              title: "Success!",
              message: "The Driver has been Saved",
              icon: "flaticon-check-mark"
            });
            this.$emit("input", driver);
            this.clearData();
          } else {
            this.$notify({
              type: "danger",
              title: "Error!",
              message: "There was an error saving the Driver, please try again",
              icon: "flaticon-remove"
            });
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "There was an error saving the Driver, please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.send = false;
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "There was an error saving the Driver, please try again",
          icon: "flaticon-remove"
        });
      }
    },
    phoneNumberEvent(value, payload) {
      let result = payload;
      if (result.isValid) {
        this.driver.person.numbre_phone = result.number.e164;
        this.$v.driver.person.numbre_phone.$model = value;
      } else {
        this.driver.person.numbre_phone = value;
        this.$v.driver.person.numbre_phone.$model = value;
      }
    },
    clearData() {
      this.driver = {
        person: {
          first_name: "",
          last_name: "",
          full_name: "",
          gender: "",
          phone: ""
        },
        profile: {
          image: ""
        },
        address: {
          country: "",
          state: "",
          city: "",
          street: "",
          postal_code: "",
          house_phone: ""
        },
        license: {
          number: "",
          exppiration: "",
          image: ""
        },
        relationship: {
          type: "in-house",
          branch: "",
          hire_date: moment().format(),
          status: false,
          duty: "off",
          vehicle: null,
          vehicles: [],
          auto_assign: false
        },
        account: {
          email: "",
          status: true
        }
      };
      this.phoneNumber = "";
      this.$v.driver.$reset();
    },
    closeModal() {
      this.clearData();
      this.$emit("close", false);
    }
  },
  computed: {
    ...mapGetters(["sesion"])
  },
  validations: {
    driver: {
      person: {
        first_name: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(20),
          ValName
        },
        last_name: {
          minLength: minLength(2),
          maxLength: maxLength(20),
          ValName
        },
        numbre_phone: {
          required,
          minLength: minLength(7),
          maxLength: maxLength(25)
        }
      }
    }
  }
};
</script>
